var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcYes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 584,
    height: 584,
    viewBox: "0 0 584 584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "114.1%",
    height: "114.1%",
    x: "-7.6%",
    y: "-6.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: "116.6%",
    height: "116.6%",
    x: "-8.9%",
    y: "-7.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 9,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.454901961 0 0 0 0 0.811764706 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0.454901961 0 0 0 0 0.811764706 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M256,0 C266.658,0 275.297,8.638 275.297,19.297 C275.297,29.955 266.658,38.593 256,38.593 C136.124,38.593 38.593,136.124 38.593,256 C38.593,375.883 136.124,473.407 256,473.407 C375.883,473.407 473.407,375.883 473.407,256 C473.407,245.341 482.045,236.703 492.703,236.703 C503.362,236.703 512,245.342 512,256 C512,397.154 397.154,512 256,512 C114.84,512 0,397.154 0,256 C0,114.84 114.84,0 256,0 Z M470.075,69.963 C477.607,62.437 489.828,62.45 497.36,69.995 C504.886,77.54 504.873,89.761 497.322,97.286 L251.613,342.351 C247.998,345.953 243.091,347.979 237.99,347.979 C237.855,347.979 237.719,347.979 237.578,347.973 C232.329,347.864 227.351,345.619 223.794,341.753 L126.668,236.272 C119.451,228.431 119.953,216.223 127.794,209.006 C135.641,201.79 147.843,202.298 155.06,210.132 L238.582,300.845 L470.075,69.963 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(39 32)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#000",
    filter: "url(#c)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#74CF00"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#74CF00",
    d: "M256,0 C266.658,0 275.297,8.638 275.297,19.297 C275.297,29.955 266.658,38.593 256,38.593 C136.124,38.593 38.593,136.124 38.593,256 C38.593,375.883 136.124,473.407 256,473.407 C375.883,473.407 473.407,375.883 473.407,256 C473.407,245.341 482.045,236.703 492.703,236.703 C503.362,236.703 512,245.342 512,256 C512,397.154 397.154,512 256,512 C114.84,512 0,397.154 0,256 C0,114.84 114.84,0 256,0 Z M470.075,69.963 C477.607,62.437 489.828,62.45 497.36,69.995 C504.886,77.54 504.873,89.761 497.322,97.286 L251.613,342.351 C247.998,345.953 243.091,347.979 237.99,347.979 C237.855,347.979 237.719,347.979 237.578,347.973 C232.329,347.864 227.351,345.619 223.794,341.753 L126.668,236.272 C119.451,228.431 119.953,216.223 127.794,209.006 C135.641,201.79 147.843,202.298 155.06,210.132 L238.582,300.845 L470.075,69.963 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYes);
export default __webpack_public_path__ + "static/media/ic_yes.48c0b53cf2d2e66572f63b1558a1e031.svg";
export { ForwardRef as ReactComponent };